import { sendMessage } from 'q2-tecton-common/lib/utility/message-bus';
import { Maybe } from 'maybe-not';

export function actionRequired(moduleId: string, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('actionRequired')) {
        return;
    }

    return function actionRequired(uuid: string, title: string, message?: string): void {
        return sendMessage(
            'actionRequired',
            Maybe.just(
                JSON.stringify({
                    uuid: `${moduleId}-${uuid}`,
                    title,
                    message
                })
            )
        );
    };
}

export function removeActionRequired(moduleId: string, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('actionRequired')) {
        return;
    }

    return function removeActionRequired(uuid: string): void {
        return sendMessage(
            'removeActionRequired',
            Maybe.just(
                JSON.stringify({
                    uuid: `${moduleId}-${uuid}`
                })
            )
        );
    };
}
